export enum PageSize {
    Small = 5,
    Medium = 10,
    Large = 25,
    ExtraLarge = 50
}

export enum Page {
    First = 0,
    Second = 1
}
